import type { RailMaintenanceTranslations } from "../interfaces/railMaintenance";

export const railMaintenanceTranslations: RailMaintenanceTranslations = {
  badge: "En mantenimiento",
  send_title: "{{country}}: envíos en mantenimiento",
  send_text:
    "Esperamos tenerlos activos pronto. Si tienes un envío urgente, escríbenos por WhatsApp y lo procesamos por otra vía.",
  send_whatsapp_message: "Hola, tengo un envío urgente. Destino: {{country}}.",
  receive_title: "{{country}}: depósitos en mantenimiento",
  receive_text:
    "Esperamos tenerlos activos pronto. Si necesitas recibir un pago con urgencia, escríbenos por WhatsApp y te ayudamos.",
  receive_whatsapp_message: "Hola, necesito recibir un pago urgente. País: {{country}}.",
  convert_title: "{{currency}}: envíos en mantenimiento",
  convert_text:
    "Puedes convertir a {{currency}}. Para enviar ese saldo tienes que hablar con soporte por WhatsApp al {{phone}}; el proceso puede tardar un poco más de lo usual.",
  convert_whatsapp_message: "Hola, necesito enviar un saldo en {{currency}}.",
  buy_title: "Compra de {{asset}} en mantenimiento",
  buy_text:
    "Esperamos tenerla activa pronto. Si necesitas comprar con urgencia, escríbenos por WhatsApp y te ayudamos.",
  buy_whatsapp_message: "Hola, necesito comprar {{asset}} con urgencia.",
  sell_title: "Venta de {{asset}} en mantenimiento",
  sell_text:
    "Esperamos tenerla activa pronto. Si necesitas vender con urgencia, escríbenos por WhatsApp y te ayudamos.",
  sell_whatsapp_message: "Hola, necesito vender {{asset}} con urgencia.",
  card_top_up_title: "Carga desde pesos en mantenimiento",
  card_top_up_text:
    "Esperamos tenerla activa pronto. Puedes cargar la tarjeta con otra opción o, si es urgente, escríbenos por WhatsApp.",
  card_top_up_whatsapp_message: "Hola, necesito cargar mi tarjeta desde pesos con urgencia.",
  help_line: "¿Necesitas ayuda? Escríbenos al {{phone}}.",
  whatsapp_cta: "Escribir por WhatsApp",
};
